class Curve {
    constructor() {
        this.curve = ''
        this.items_registered = '' // CAD: Quantidade de produtos únicos cadastrados
        this.items_in_stock = '' // EST: Quantidade de produtos únicos cadastrados que possuam ao menos uma peça em estoque
        this.items_new = '' // Novos itens
        this.items_discontinuing = '' // EM DESC: Em descontinuação
        this.items_discontinued = '' // DESC: Descontinuado
        this.items_obsolete = ''
        this.stock_count = '' // UN: Unidades de uma faixa em estoque
        this.stock_cost = '' // R$: Custo total das unidades em estoque
        this.stock_percentual = '' // L: Percentual de investimento em itens nessa curva (preço * quantidade), em relação ao valor total
        this.stock_new = '' // Novos: Produtos novos em estoque
        this.stock_discontinuing = '' // EM DESC: Em descontinuação
        this.stock_discontinued = '' // DESC: Descontinuado
        this.stock_obsolete = ''
        this.stock_coverage = '' // TC: Tempo de cobertura, dias onde estoque - dias*(vendas por dia) > 0
        this.stock_cubage = '' //Cubagem(cm³)
        //this.stock_coverage_meta = '' // TC META: Tempo de cobertura (meta),

        this.stock_new_abs = ''
        this.stock_discontinuing_abs = ''
        this.stock_discontinued_abs = ''
        this.stock_obsolete_abs = ''

        this.stock_and_new = ''
        this.stock_and_obsolete = ''
        this.stock_and_discontinuing = ''
        this.stock_and_discontinued = ''
        this.no_stock_and_new = ''
        this.no_stock_and_discontinuing = ''
        this.no_stock_and_discontinued = ''
        this.obsolete_and_discontinuing = ''
        this.obsolete_and_discontinued = ''
    }

    static get fieldNames() {
        return {
            curve: {
                name: 'Curva',
                tooltip:
                    'Classificação de produtos, sendo AA o maior valor agregado e CC o menor valor agregado.'
            },
            items_registered: {
                name: 'Cad.',
                tooltip: 'Quantidade de produtos únicos cadastrados.'
            },
            items_in_stock: {
                name: 'Est.',
                tooltip:
                    'Quantidade de produtos únicos cadastrados que possuam ao menos uma peça em estoque.'
            },
            items_new: {
                name: 'Novos',
                tooltip: 'Quantidade de produtos Novos por curva de classificação.'
            },
            items_discontinuing: {
                name: 'Em Desc.',
                tooltip: 'Quantidade de produtos em processo de Descontinuação por curva de classificação.'
            },
            items_discontinued: {
                name: 'Desc.',
                tooltip: 'Quantidade de produtos Descontinuados   por curva de classificação.'
            },
            items_obsolete: {
                name: 'Obs.',
                tooltip: 'Quantidade de produtos Obsoletos   por curva de classificação.'
            },
            stock_count: {
                name: 'Un.',
                tooltip: 'Soma da quantidade dos produtos cadastrados por curva de classificação.'
            },
            stock_cubage: {
                name: 'Cub.',
                tooltip: 'Soma da cubagem dos produtos cadastrados por curva de classificação.'
            },
            stock_cost: {
                name: 'R$',
                tooltip: 'Custo total (em R$) das unidades em estoque.'
            },
            stock_percentual: {
                name: '%',
                tooltip:
                    'Percentual de investimento nos itens por curva de classificação, em relação ao valor total.'
            },
            stock_new: {
                name: 'Novos (%)',
                tooltip: 'Percentual de investimento da categoria "Novos", em relação ao investimento total.'
            },
            stock_discontinuing: {
                name: 'Em Desc. (%)',
                tooltip: 'Percentual de investimento da categoria "Descontinuação", perante ao investimento total.'
            },
            stock_discontinued: {
                name: 'Desc. (%)',
                tooltip: 'Percentual de investimento da categoria "Descontinuado", perante ao investimento total.'
            },
            stock_obsolete: {
                name: 'Obs. (%)',
                tooltip: 'Percentual de investimento da categoria "Obsoletos", perante ao   investimento total.'
            },
            stock_coverage: {
                name: 'T.C.',
                tooltip: 'Período em que o estoque é suficiente para cobrir a demanda, baseado nas últimas vendas (Em dias).'
            },
            items_no_stock: {
                name: 'Sem. Est.',
                tooltip: ''
            },
            items_active: {
                name: 'Ativo',
                tooltip: ''
            },
            items_inactive: {
                name: 'Inativo',
                tooltip: ''
            }
            //stock_coverage_meta: 'TC Meta',
        }
    }

    static get fieldTypes() {
        return {
            curve: 'string',
            items_registered: 'int',
            items_in_stock: 'int',
            items_new: 'int',
            items_discontinuing: 'int',
            items_discontinued: 'int',
            items_obsolete: 'int',
            stock_count: 'int',
            stock_cubage: 'float',
            stock_cost: 'float',
            stock_percentual: 'float',
            stock_new: 'float',
            stock_discontinuing: 'float',
            stock_discontinued: 'float',
            stock_obsolete: 'float',
            stock_coverage: 'float',
            items_no_stock: 'float',
            items_active: 'float',
            items_inactive: 'float'
            //stock_coverage_meta: 'TC Meta',
        }
    }

    static get fieldClasses() {
        let classes = {}
        Object.keys(this.fieldNames).forEach(key => {
            let prefix = key.split('_')[0]
            if (prefix == 'items' || prefix == 'stock') {
                classes[key] = prefix
            } else {
                classes[key] = 'curve'
            }
        })
        return classes
    }

    static get visibleFields() {
        return {
            curve: true,
            items_registered: true,
            items_in_stock: true,
            items_new: true,
            items_discontinuing: true,
            items_discontinued: true,
            items_cubage: true,
            items_obsolete: true,
            stock_count: true,
            stock_cubage: true,
            stock_cost: true,
            stock_percentual: true,
            stock_new: true,
            stock_discontinuing: true,
            stock_discontinued: true,
            stock_obsolete: true,
            stock_coverage: true,

            items_no_stock: false,
            items_active: false,
            items_inactive: false
            //stock_coverage_meta: true,
        }
    }

    static get clickableFields() {
        return {
            curve: false,
            items_registered: true,
            items_in_stock: true,
            items_new: true,
            items_discontinuing: true,
            items_discontinued: true,
            items_cubage: false,
            items_obsolete: true,
            stock_count: false,
            stock_cubage: false,
            stock_cost: false,
            stock_percentual: false,
            stock_new: false,
            stock_discontinuing: false,
            stock_discontinued: false,
            stock_obsolete: false,
            stock_coverage: false
            //stock_coverage_meta: true,
        }
    }
}

export default Curve

export { Curve }
